import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import GamePage from "./pages/GamePage";
import "./App.css";

function App() {
  return (
    <div className="App min-h-screen bg-dark">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<GamePage />} />
        </Routes>
      </BrowserRouter>
      <Toaster 
        position="top-center" 
        toastOptions={{
          style: {
            background: '#1A1A1A',
            color: '#EDEDED',
            border: '1px solid rgba(255,255,255,0.1)',
          },
        }}
      />
    </div>
  );
}

export default App;
